import { css } from 'aphrodite';
import * as React from 'react';
import Draggable, { DraggableProps } from 'react-draggable';
import { styleSheet } from './styles';

interface IProps extends Partial<DraggableProps> {
	isDraggable: boolean;
}

export const AidaDraggable: React.FC<React.PropsWithChildren<IProps>> = props => {
	const { children, isDraggable, ...restProps } = props;
	const nodeRef = React.useRef(null);
	if (!isDraggable) {
		return <>{children}</>;
	}

	const child = React.Children.only(children) as React.ReactElement;

	return (
		<Draggable
			handle='.drag-handle'
			defaultClassName={css(styleSheet.draggable, isDraggable && styleSheet.draggableHandle)}
			defaultClassNameDragging={css(styleSheet.dragging)}
			bounds='body'
			nodeRef={nodeRef}
			{...restProps}
		>
			{React.cloneElement(child, { ref: nodeRef })}
		</Draggable>
	);
};
